<template>
    <section>
        <v-btn text class="px-0 green--text back" @click="$router.go(-1)" absolute v-if="$vuetify.breakpoint.mdAndDown">
            <svg v-svg="'icon-back'" size="11" fill="currentColor" class="mr-1"></svg>
            <span>{{$t('global.back')}}</span>
        </v-btn>

        <section class="text-center my-7">
            <avatar :configs="uploadConfigs"
                    :src="HOME_USER.avatar || require('@/../public/images/Avatar.png')"
                    @successUpload="uploadSuccess">
            </avatar>
        </section>

        <section class="sectionForm mx-auto">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <ValidationProvider :name="$t('auth.name')" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                        <v-text-field :label="$t('auth.name')"
                                      v-model="user.name"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider :name="$t('auth.surname')" :rules="{required: true, max: 80, regex: /[\u0530-\u058F,a-zA-Z]/}" v-slot="{ errors }">
                        <v-text-field :label="$t('auth.surname')"
                                      v-model="user.sur_name"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-name'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider vid="phone" :name="$t('auth.phone')" :rules="{required : true, regex: /([0][1|3-9]{2})([0-9]{6})/, max: 9}" v-slot="{ errors }">
                        <v-text-field :label="$t('auth.phone')"
                                      v-model="user.phone"
                                      maxlength="9"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-phone'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider vid="email" :name="$t('auth.email')" rules="required|email" v-slot="{ errors }">
                        <v-text-field :label="$t('auth.email')"
                                      type="email"
                                      v-model="user.email"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-email'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-menu ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <ValidationProvider :name="$t('auth.birth')" rules="required" v-slot="{ errors }">
                                <v-text-field :value="user.date_of_birth"
                                              :label="$t('auth.birth')"
                                              readonly
                                              v-bind="attrs"
                                              v-on="on"
                                              :loading="loadingRequest"
                                >
                                    <template v-slot:prepend-inner>
                                        <svg v-svg="'icon-date'" size="15" class="mr-1"></svg>
                                    </template>
                                </v-text-field>
                                <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </template>

                        <v-date-picker :active-picker.sync="activePicker"
                                       v-model="user.date_of_birth"
                                       @change="$refs.menu.save($event)"
                                       :max="moment(new Date()).subtract(0, 'years').toISOString()"
                                       :min="moment(new Date()).subtract(60, 'years').toISOString()"
                                       color="green"
                        ></v-date-picker>
                    </v-menu>

                    <ValidationProvider vid="old_password" :name="$t('profile.old_password')" :rules="{required: (user.password !== '' && user.password != null)}" v-slot="{ errors }">
                        <v-text-field :label="$t('profile.old_password')" type="password"
                                      v-model="user.old_password"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-password'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider vid="password" :name="$t('auth.new_password')" :rules="{required: (user.old_password !== '' && user.old_password != null), min:6}" v-slot="{ errors }">
                        <v-text-field :label="$t('auth.new_password')" type="password"
                                      v-model="user.password"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-password'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider :name="$t('profile.re_password')" rules="confirmed:password" v-slot="{ errors }">
                        <v-text-field :label="$t('profile.re_password')" type="password"
                                      v-model="user.password_confirmation"
                                      :loading="loadingRequest"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-password'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-card-actions class="justify-center mt-10">
                        <v-btn class="white--text" color="green" type="submit" :loading="loadingSave" width="90" height="30">{{$t('profile.save')}}</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </section>
    </section>
</template>

<script>
    import Avatar from '@/components/Avatar';
    export default {
        components: {
            Avatar,
        },
        data(){
            return {
                uploadConfigs: {
                    uploadUrl: `${process.env.VUE_APP_API_URL}/me/avatar/upload`,
                    size: (1024 * 1024 * 2),
                    headers: {'Authorization': localStorage.getItem('home_token')}
                },
                user: {},
                menu: false,
                loadingRequest: false,
                loadingSave: false,
                activePicker: null,
            }
        },

        watch: {
            menu (val) {
                val && setTimeout(() => (this.activePicker = 'YEAR'))
            },
        },

        mounted() {
            this.getData();
        },

        methods: {
            uploadSuccess(){
                let user = this.HOME_USER;
                user.avatar = `${this.API_URL}/storage/avatars/${user.id}.jpg?` + Math.random();
                this.$store.dispatch('CHANGE_USER_HOME', user).then(() => this.$store.dispatch('alert', {type: 1, message: this.$t('avatar.updated')}));
            },
            getData() {
                this.loadingRequest = true;
                this.$api('users').me().then((res) => {
                    this.user = res.data.user;
                    this.loadingRequest = false;
                })
            },
            save() {
                this.loadingSave = true;
                this.$api('users').meUpdate(this.user).then((res) => {
                    delete this.user.password_confirmation;
                    delete this.user.password;
                    delete this.user.old_password;

                    this.$store.dispatch('CHANGE_USER_HOME', res.data.user);
                    this.$store.dispatch('alert', {type: 1, message: this.$t('global.success_edited')})
                }).catch((err) => {
                    if (err.response.status === 422) this.$refs.form.setErrors(err.response.data);
                }).finally(() => {
                    this.loadingSave = false;
                })
            }
        },
    }
</script>

<style scoped lang="scss">
    .sectionForm{
        max-width: 520px;
    }
</style>